import { CardHeader, Grid, IconButton } from "@mui/material";
import Etudes from "./cv/Etudes";
import Formations from "./cv/Formations";
import ExperienceProfessionnels from "./cv/ExperienceProfessionnels";
import AutreCompetence from "./cv/AutreCompetence";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Identite from "./cv/Identite";

const CV = () => {
  const navigate = useNavigate();
  return (
    <Grid container display={"flex"} flexDirection={"row"} mr={2}>
      <CardHeader
        avatar={
          <IconButton
            title="Retour"
            onClick={(e) => navigate("/mon-profile?tab=1")}
          >
            <KeyboardBackspaceIcon />
          </IconButton>
        }
        titleTypographyProps={{ variant: "h5" }}
        title="Detail du CV"
      />
      <Grid item xs={12}>
        <Grid mt={2.5}>
          <Identite />
        </Grid>
        <Grid mt={2.5}>
          <ExperienceProfessionnels />
        </Grid>
        <Grid mt={2.5}>
          <Etudes />
        </Grid>
        {/* <Grid mt={2.5}>
          <DomaineCompetences />
        </Grid> */}
        <Grid mt={2.5}>
          <Formations />
        </Grid>
        <Grid mt={2.5}>
          <AutreCompetence />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CV;
